<template>
  <nav class="bg-white flex items-center justify-between px-8 py-4 w-full h-16 border-b">
    <div class="text-lg font-semibold text-gray-800">App Control Center</div>
    <div class="relative">
      <span
        class="absolute -top-2 -right-2 bg-blue-900 text-white text-xs rounded-full px-1.5 py-0.5 flex items-center justify-center"
        style="min-width: 20px; height: 20px"
        >12</span
      >
      <span class="material-icons text-3xl text-gray-700">notifications_none</span>
    </div>
  </nav>
</template>

<script>
export default {
  name: "ReNavbar",
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/icon?family=Material+Icons");
</style>
